import React from 'react';
import './Footer.css';
import moment from 'moment';

const Footer = () => {
  const currentYear = moment().year();
  return (
    <footer className="home-footer">
      <p>Copyright © <i>DSN/UAM</i> {currentYear} - Tous droits réservés</p>
    </footer>
  );
};

export default Footer;
